<template>
  <v-container class="container1">
    <v-container class="">
      <ValidationObserver v-slot="{ invalid, handleSubmit }">
        <v-form
          style="
            gap: 20px;
            padding: 30px;
            display: flex;
            flex-direction: column;
          "
          @submit.prevent="handleSubmit(onSubmit)"
          autocomplete="off"
        >
          <v-checkbox
            color="#6D6963"
            v-model="invoiceForCompany"
            :label="`Faktura na firmę`"
            style="color: #6d6963"
            :disabled="busy"
          ></v-checkbox>
          <VTextFieldWithValidation
            rules="email|required"
            required
            label="E-mail"
            type="email"
            color="white"
            :disabled="busy"
            v-model.trim="email"
            autocomplete="none"
            placeholder="Wpisz e-mail..."
          />
          <VTextFieldWithValidation
            rules="email|required"
            required
            label="Potwierdź e-mail"
            type="email"
            color="white"
            :disabled="busy"
            v-model.trim="confirmEmail"
            autocomplete="none"
            placeholder="Powtórz e-mail..."
          />

          <VTextFieldWithValidation
            rules="email|RegexEmail"
            label="Email osoby obdarowywanej (opcjonalnie)"
            type="email"
            color="white"
            :disabled="busy"
            v-model="giftRecipientEmail"
            autocomplete="none"
            v-if="selectedGiftCard"
            placeholder="Wpisz e-mail..."
          />

          <!-- OSOBA PRYWATNA: imię i nazwisko -->
          <VTextFieldWithValidation
            v-if="!invoiceForCompany"
            :rules="!invoiceForCompany ? 'required' : ''"
            :disabled="busy"
            required
            label="Imię"
            type="text"
            color="white"
            v-model="firstName"
            placeholder="Wpisz imię..."
          />
          <VTextFieldWithValidation
            v-if="!invoiceForCompany"
            :rules="!invoiceForCompany ? 'required' : ''"
            :disabled="busy"
            required
            label="Nazwisko"
            type="text"
            color="white"
            v-model="lastName"
            placeholder="Wpisz nazwisko..."
          />

          <VTextFieldWithValidation
            v-if="selectedOrder || submitAction"
            rules="numeric|phone"
            label="Numer telefonu"
            color="white"
            :disabled="busy"
            v-model="phone"
            placeholder="Wpisz numer telefonu..."
          />

          <!-- FIRMA: NIP + przycisk pobrania danych z GUS + nazwa firmy -->
          <VTextFieldWithValidation
            v-if="invoiceForCompany"
            rules="required|numeric|NIP"
            required
            label="Numer NIP"
            color="white"
            :disabled="busy"
            v-model="companyNIP"
            placeholder="Wpisz numer NIP..."
          />
          <div v-if="invoiceForCompany" class="gus-actions">
            <v-btn
              type="button"
              block
              class="gus-btn"
              color="#C5C0B9"
              style="
                color: #54514c;
                border-radius: 16px;
                text-transform: none;
                height: 44px;
              "
              :loading="gusLoading"
              :disabled="
                loading ||
                transaction.show ||
                !isNipValidLength ||
                companyDataFromGus
              "
              @click="fetchCompanyFromGus"
            >
              {{ gusLoading ? "Pobieranie..." : "Pobierz dane z GUS" }}
            </v-btn>
            <div
              v-if="companyDataFromGus"
              @click="clearGusData"
              style="
                cursor: pointer;
                font-size: 12px;
                margin-top: 8px;
                text-decoration: underline;
              "
            >
              Wpisz ręcznie
            </div>
          </div>
          <VTextFieldWithValidation
            v-if="invoiceForCompany"
            :rules="invoiceForCompany ? 'required' : ''"
            required
            label="Nazwa firmy"
            color="white"
            :disabled="busy || companyDataFromGus"
            v-model="companyName"
            placeholder="Wpisz nazwę firmy..."
          />

          <!-- ADRES (wspólny dla firmy i osoby prywatnej) -->
          <VTextFieldWithValidation
            rules="required"
            required
            label="Adres (ulica, numer domu i lokalu)"
            color="white"
            :disabled="busy || (invoiceForCompany && companyDataFromGus)"
            v-model="address"
            placeholder="Wpisz adres..."
          />
          <VTextFieldWithValidation
            rules="required|postalCode"
            required
            label="Kod pocztowy"
            color="white"
            :disabled="busy || (invoiceForCompany && companyDataFromGus)"
            v-model="postalCode"
            placeholder="np. 00-000"
          />
          <VTextFieldWithValidation
            rules="required"
            required
            label="Miasto"
            color="white"
            :disabled="busy || (invoiceForCompany && companyDataFromGus)"
            v-model="city"
            placeholder="Wpisz miasto..."
          />
          <VSelectWithValidation
            rules="required"
            required
            label="Kraj"
            color="white"
            :disabled="busy || (invoiceForCompany && companyDataFromGus)"
            v-model="country"
            :items="countryOptions"
          />

          <VTextFieldWithValidation
            v-if="!isCoursesTicket"
            label="Kod rabatowy"
            color="white"
            :disabled="busy"
            v-model="discountCode"
            placeholder="Wpisz kod rabatowy..."
          />

          <v-checkbox
            v-if="selectedPackage"
            color="#6D6963"
            v-model="agreementRequired"
            :label="`Wyrażam zgodę na rozpoczęcie świadczenia usług i udostępnienie treści cyfrowych natychmiast po zakupie, przed upływem 14 dni. Rozumiem, że w związku z tym tracę prawo odstąpienia od umowy.`"
            :disabled="busy"
            :required="true"
          ></v-checkbox>

          <v-checkbox
            v-if="
              profile.refLinksAmount &&
              selectedPackage &&
              !selectedGiftCard &&
              !selectedOrder
            "
            color="#6D6963"
            v-model="useRefLinksAmount"
            :label="`Chcę wykorzystać rabat z poleceń Platformy`"
            :disabled="busy"
          ></v-checkbox>

          <div v-if="selectedOrder" class="mb-8">
            <v-checkbox
              color="#6D6963"
              v-model="markAllCheckboxes"
              :label="`Zaznacz wszystkie obowiązkowe`"
              :disabled="busy"
              @change="handleMarkAllCheckboxes"
            ></v-checkbox>
            <v-checkbox
              color="#6D6963"
              v-model="checkbox1"
              :label="`* Oświadczam, iż jestem osobą pełnoletnią posiadającą pełną zdolność do czynności prawnych i składania oświadczeń woli.`"
              :disabled="busy"
            ></v-checkbox>

            <v-checkbox
              color="#6D6963"
              v-model="checkbox2"
              :label="`* Oświadczam, że jestem świadoma/y swojego stanu zdrowia i nie mam żadnych przeciwskazań zdrowotnych do bezpiecznego dla zdrowia udziału w zajęciach organizowanych przez Daga Joga. Przystępuję do zajęć na własną odpowiedzialność, a Organizator – Daga Joga – nie ponosi odpowiedzialności za odniesione przeze mnie kontuzje i uszczerbki na zdrowiu, jak również ewentualny negatywny wpływ mojego udziału w zajęciach na stan mojego zdrowia.`"
              :disabled="busy"
            ></v-checkbox>

            <v-checkbox
              color="#6D6963"
              v-model="checkbox3"
              :label="`* Oświadczam, że nie jestem w ciąży.`"
              :disabled="busy"
            ></v-checkbox>

            <v-checkbox
              color="#6D6963"
              v-model="newsletter"
              :label="`Zapisz się do newslettera`"
              :disabled="busy"
            ></v-checkbox>
            <i
              >* W przypadku posiadania przez osobę zamierzającą uczestniczyć w
              zajęciach organizowanych przez Daga Joga jakichkolwiek stanów po
              przebytych urazach lub schorzeniach kostno-stawowych, układu
              mięśniowego lub ścięgien oraz ośrodkowego układu nerwowego, przed
              złożeniem Oświadczenia należy poinformować Organizatora na adres
              e-mail
              <a class="checkbox-email" href="mailto:daga@dagajoga.pl"
                >daga@dagajoga.pl</a
              >. Organizator ma prawo odmówić Uczestnikowi udziału w zajęciach
              bez podania przyczyny.
            </i>
          </div>
          <div
            v-show="!invalid || !transaction.show"
            @click="resetForm"
            style="cursor: pointer; margin-left: auto; font-size: 12px"
          >
            Zresetuj formularz
            <svg
              width="21"
              height="10"
              viewBox="0 0 31 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 9H30V7H0V9Z"
                fill="#8B857D"
              />
            </svg>
          </div>
          <div
            class=""
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div class="sub-title" style="font-size: 20px; text-align: left">
              Całkowity koszt:
            </div>
            <div
              style="color: #54514c; font-weight: 500"
              v-if="transaction.data.p24_amount"
            >
              {{ (transaction.data.p24_amount / 100).toFixed(2) }} zł
            </div>
            <div
              style="color: #54514c; font-weight: 500"
              v-if="!transaction.data.p24_amount && selectedPackage"
            >
              {{ selectedPackage.price }} zł
            </div>
          </div>

          <div class="submit-content">
            <v-btn
              type="submit"
              block
              color="#C5C0B9"
              style="
                color: #8b857d;
                border-radius: 16px;
                text-transform: none;
                padding: 18px 36px 18px 36px;
                height: 50px;
              "
              :disabled="invalid || transaction.show"
              :loading="loading"
            >
              Zatwierdź dane
            </v-btn>
          </div>
        </v-form>

        <form
          :action="PAYMENT_URL"
          method="post"
          id="paymentForm"
          class="justify-center d-flex align-center"
        >
          <input
            type="hidden"
            name="p24_time_limit"
            :value="
              transaction.data.p24_expiration_time
                ? transaction.data.p24_expiration_time
                : 60
            "
          />
          <input
            type="hidden"
            name="p24_session_id"
            :value="transaction.data.p24_session_id"
          />
          <input
            type="hidden"
            name="p24_merchant_id"
            :value="transaction.data.p24_merchant_id"
          />
          <input
            type="hidden"
            name="p24_pos_id"
            :value="transaction.data.p24_pos_id"
          />
          <input
            type="hidden"
            name="p24_amount"
            :value="transaction.data.p24_amount"
          />
          <input
            type="hidden"
            name="p24_currency"
            :value="transaction.data.p24_currency"
          />
          <input
            type="hidden"
            name="p24_description"
            :value="transaction.data.p24_description"
          />
          <input
            type="hidden"
            name="p24_country"
            :value="transaction.data.p24_country"
          />
          <input
            type="hidden"
            name="p24_email"
            :value="transaction.data.p24_email"
          />
          <input
            type="hidden"
            name="p24_url_return"
            :value="transaction.data.p24_url_return"
          />
          <input
            type="hidden"
            name="p24_url_status"
            :value="transaction.data.p24_url_status"
          />
          <input
            type="hidden"
            name="p24_api_version"
            :value="transaction.data.p24_api_version"
          />
          <input
            type="hidden"
            name="p24_sign"
            :value="transaction.data.p24_sign"
          />
          <v-btn
            v-if="transaction.show"
            type="button"
            block
            class="mt-5 mb-5 primary-button"
            style="color: #54514c"
            :loading="loading"
            @click="handleStartedTimePackagePayment"
          >
            Dokonaj płatności
          </v-btn>
        </form>
      </ValidationObserver>

      <div class="agreements">
        <p>
          Jeśli chcesz skorzystać z płatności PAYPAL, kliknij przycisk dokonaj
          płatności a następnie przejdź do zakładki inne. Składając zamówienie,
          wyrażasz zgodę na dostarczenie treści cyfrowych lub świadczenie usługi
          przed upływem terminu do odstąpienia od umowy zawartej na odległość.
          Potwierdzasz, że tym samym tracisz prawo do odstąpienia od umowy.
        </p>
      </div>
    </v-container>
  </v-container>
</template>

<script>
import VTextFieldWithValidation from "../inputs/VTextFieldWithValidation";
import VSelectWithValidation from "../inputs/VSelectWithValidation";
import { ValidationObserver } from "vee-validate";
import { PAYMENT_URL } from "../../axios.js";
import { countryItems, toCountryCode } from "../../utils/countries";
export default {
  name: "PaymentForm",

  components: {
    VTextFieldWithValidation,
    VSelectWithValidation,
    ValidationObserver,
  },
  props: {
    selectedPackage: Object,
    profile: Object,
    selectedGiftCard: Object,
    selectedOrder: Object,
    isCoursesTicket: Boolean,
    isExtendedSubscription: Boolean,
    // Generyczny tryb reużycia: widok podaje akcję Vuex i swoje parametry.
    // Gdy ustawione, PaymentForm dispatch'uje submitAction z zebranymi danymi faktury.
    submitAction: {
      type: String,
      default: "",
    },
    submitParams: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      email: "",
      confirmEmail: "",
      firstName: "",
      lastName: "",
      discountCode: "",
      companyName: "",
      companyNIP: "",
      address: "",
      postalCode: "",
      city: "",
      country: "PL",
      countryOptions: countryItems,
      loading: false,
      gusLoading: false,
      companyDataFromGus: false,
      PAYMENT_URL,
      newsletter: true,
      invoiceForCompany: false,
      giftRecipientEmail: "",
      phone: "",
      markAllCheckboxes: false,
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      useRefLinksAmount: false,
      agreementRequired: false,
    };
  },
  watch: {
    profile: {
      immediate: true,
      handler(profile) {
        if (!profile || this._prefilled) return;
        this._prefilled = true;
        this.prefillFromProfile(profile);
      },
    },
    invoiceForCompany(val) {
      // Przełączenie na osobę prywatną - reset danych firmowych i blokady GUS.
      if (!val) {
        this.companyName = "";
        this.companyNIP = "";
        this.companyDataFromGus = false;
      }
    },
    postalCode(val) {
      // Auto-format kodu pocztowego do XX-XXX.
      const digits = String(val || "")
        .replace(/\D/g, "")
        .slice(0, 5);
      const formatted =
        digits.length > 2 ? `${digits.slice(0, 2)}-${digits.slice(2)}` : digits;
      if (formatted !== val) this.postalCode = formatted;
    },
  },
  computed: {
    transaction: function () {
      return this.$store.getters["payment/getTransInfo"];
    },
    // Pola zablokowane gdy: wysyłka zamówienia / trwa transakcja / pobieranie z GUS
    busy() {
      return this.loading || this.transaction.show || this.gusLoading;
    },
    isPackage24h() {
      return this.$route.query.recording;
    },
    isNipValidLength() {
      return String(this.companyNIP || "").replace(/\D/g, "").length === 10;
    },
  },
  mounted() {
    this.$store.commit("payment/SET_INIT_VALUES");
  },
  destroyed() {
    this.$store.commit("payment/SET_INIT_VALUES");
  },
  methods: {
    prefillFromProfile(profile) {
      this.email = profile.email;
      this.confirmEmail = profile.email;
      if (profile.firstName) this.firstName = profile.firstName;
      if (profile.lastName) this.lastName = profile.lastName;
      if ((!this.firstName || !this.lastName) && profile.name) {
        const parts = String(profile.name).trim().split(/\s+/);
        if (!this.firstName)
          this.firstName =
            parts.length > 1 ? parts.slice(0, -1).join(" ") : parts[0] || "";
        if (!this.lastName)
          this.lastName = parts.length > 1 ? parts[parts.length - 1] : "";
      }
      if (profile.company) this.companyName = profile.company;
      const savedNip =
        profile.nip && String(profile.nip).trim() !== ""
          ? String(profile.nip).trim()
          : "";
      if (savedNip) this.companyNIP = savedNip;
      if (profile.address) this.address = profile.address;
      if (profile.postalCode) this.postalCode = profile.postalCode;
      if (profile.city) this.city = profile.city;
      this.country = toCountryCode(profile.country);
      // Jesli uzytkownik ma zapisane dane firmowe - domyslnie faktura na firme.
      if (profile.company && savedNip) this.invoiceForCompany = true;
    },
    async fetchCompanyFromGus() {
      const nip = String(this.companyNIP || "").replace(/\D/g, "");
      if (nip.length !== 10) return;
      this.gusLoading = true;
      try {
        const company = await this.$store.dispatch(
          "payment/getCompanyDataFromGus",
          nip
        );
        this.companyName = company.name || "";
        this.address = company.address || "";
        this.postalCode = company.postalCode || "";
        this.city = company.city || "";
        this.country = "PL";
        this.companyDataFromGus = true;
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Nie udało się pobrać danych z GUS";
        this.$store.dispatch(
          "snackbar/setSnackbar",
          { color: "red", icon: "exclamation-triangle", message },
          { root: true }
        );
        this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
      } finally {
        this.gusLoading = false;
      }
    },
    clearGusData() {
      // "Wpisz ręcznie" - odblokuj pola do edycji.
      this.companyDataFromGus = false;
    },
    async handleStartedTimePackagePayment() {
      try {
        if (
          this.selectedPackage &&
          !this.selectedGiftCard &&
          !this.selectedOrder &&
          this.transaction.data.timePackageOrderId
        ) {
          await this.$store.dispatch(
            "payment/handleStartedTimePackageTransaction",
            this.transaction.data.timePackageOrderId
          );
        }

        // Ręczne wysłanie formularza po zakończeniu operacji
        document.getElementById("paymentForm").submit();
      } catch (error) {
        this.$store.dispatch("snackbar/showSnackbar", {
          color: "red",
          message:
            "Nie udało się rozpocząć płatności. Skontaktuj się z administratorem",
        });
      }
    },
    handleMarkAllCheckboxes() {
      if (this.markAllCheckboxes) {
        this.checkbox1 = true;
        this.checkbox2 = true;
        this.checkbox3 = true;
      } else {
        this.checkbox1 = false;
        this.checkbox2 = false;
        this.checkbox3 = false;
      }
    },
    onSubmit() {
      if (this.selectedPackage && !this.agreementRequired) {
        this.$store.dispatch(
          "snackbar/setSnackbar",
          {
            color: "red",
            icon: "exclamation-triangle",
            message:
              "Musisz wyrazić zgodę na rozpoczęcie świadczenia usług i udostępnienie treści cyfrowych natychmiast po zakupie, przed upływem 14 dni.",
          },
          { root: true }
        );
        this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
        return;
      }
      if (
        this.selectedOrder &&
        (!this.checkbox1 || !this.checkbox2 || !this.checkbox3)
      ) {
        this.$store.dispatch(
          "snackbar/setSnackbar",
          {
            color: "red",
            icon: "exclamation-triangle",
            message:
              "Wymagane potwierdzenie wszystkich obowiązkowych oświadczeń",
          },
          { root: true }
        );
        this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
        return;
      }

      const fullName = `${this.firstName} ${this.lastName}`.trim();
      const invoiceFields = {
        firstName: this.firstName,
        lastName: this.lastName,
        companyName: this.companyName,
        nip: this.companyNIP,
        address: this.address,
        postalCode: this.postalCode,
        city: this.city,
        country: this.country,
        invoiceForCompany: this.invoiceForCompany,
      };

      if (
        (this.companyName && this.companyNIP && this.invoiceForCompany) ||
        (this.firstName && this.lastName && !this.invoiceForCompany)
      ) {
        this.loading = true;
        // Tryb generyczny (reużycie): dispatch akcji podanej przez widok.
        if (this.submitAction) {
          this.$store
            .dispatch(this.submitAction, {
              ...invoiceFields,
              email: this.email,
              confirmEmail: this.confirmEmail,
              name: fullName,
              phone: this.phone,
              discountCode: this.discountCode.toLowerCase().trim(),
              newsletter: this.newsletter,
              giftRecipientEmail: this.giftRecipientEmail,
              useRefLinksAmount: this.useRefLinksAmount,
              ...this.submitParams,
            })
            .catch(() => {})
            .finally(() => {
              this.loading = false;
            });
          return;
        }
        if (
          this.selectedPackage &&
          !this.selectedGiftCard &&
          !this.selectedOrder
        ) {
          let object = {
            ...invoiceFields,
            email: this.email,
            discountCode: this.discountCode.toLowerCase().trim(),
            name: fullName,
            timePackageId: this.selectedPackage.id,
            newsletter: this.newsletter,
            confirmEmail: this.confirmEmail,
            isExtendedSubscription: this.isExtendedSubscription,
            useRefLinksAmount: this.useRefLinksAmount,
          };
          this.$store
            .dispatch("payment/createTimePackageOrder", object)
            .catch(() => {})
            .finally(() => {
              this.loading = false;
            });
        } else if (this.selectedGiftCard) {
          let object = {
            ...invoiceFields,
            email: this.email,
            discountCode: this.discountCode.toLowerCase().trim(),
            name: fullName,
            newsletter: this.newsletter,
            confirmEmail: this.confirmEmail,
            giftRecipientEmail: this.giftRecipientEmail,
            giftCardId: this.selectedGiftCard.id,
          };
          this.$store
            .dispatch("payment/createUserGiftCardOrder", object)
            .catch(() => {})
            .finally(() => {
              this.loading = false;
            });
        } else if (this.selectedOrder) {
          let object = {
            ...invoiceFields,
            email: this.email,
            discountCode: this.discountCode.toLowerCase().trim(),
            name: fullName,
            phone: this.phone,
            packageId: this.selectedOrder.id,
            newsletter: this.newsletter,
            confirmEmail: this.confirmEmail,
            recording: this.isPackage24h ? true : null,
          };

          if (this.isCoursesTicket) {
            this.$store
              .dispatch("coursesTickets/createOrder", object)
              .then((data) => {
                this.$store.dispatch(
                  "payment/startTransactionForCoursesTicket",
                  data.id
                );
              })
              .catch(() => {})
              .finally(() => {
                this.loading = false;
              });
          } else {
            this.$store
              .dispatch("payment/createOrder", object)
              .catch(() => {})
              .finally(() => {
                this.loading = false;
              });
          }
        }
      } else {
        this.$store.dispatch(
          "snackbar/setSnackbar",
          {
            color: "red",
            icon: "exclamation-triangle",
            message:
              'Musisz wypełnić przynajmniej jedno z następujących: "Imię i Nazwisko" bądź "Nazwa firmy" i "Numer NIP"',
          },
          { root: true }
        );
        this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
        this.resetForm();
      }
    },
    resetForm() {
      this.$store.commit("payment/SET_INIT_VALUES");
      this.email = "";
      this.confirmEmail = "";
      this.firstName = "";
      this.lastName = "";
      this.discountCode = "";
      this.companyName = "";
      this.companyNIP = "";
      this.address = "";
      this.postalCode = "";
      this.city = "";
      this.country = "PL";
      this.companyDataFromGus = false;
      this.giftRecipientEmail = "";
    },
  },
};
</script>

<style scoped>
.checkbox-email {
  text-transform: lowercase;
  color: #54514c;
  text-decoration: none;
  cursor: pointer;
}
.reset {
  text-transform: uppercase;
  cursor: pointer;
}
.custom-placeholer-color input::placeholder {
  color: red !important;
  opacity: 1;
}
.container1 {
  background-color: #d9d9d9;
  border-radius: 20px;
  color: #8b857d;
  display: flex;
  flex-direction: column;
  padding: 40px 70px;
  filter: none !important;
  box-shadow: 0px 0px 100px #b6afa5;
  /* filter: drop-shadow(0px 0px 100px #b6afa5); */
}
/*HEADER */
h1 {
  margin-bottom: 30px;
}

/* CHECKBOX*/
.checkbox {
  padding: 5px;
}

/* CONFIRMATION SECTION */
.confirmation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
}

h3 {
  font-size: 0.9rem;
  font-weight: 600;
}

/* FORM RESET */
a {
  text-transform: uppercase;
}
.a-tag {
  color: #fff;
  font-size: 0.7rem;
}

/* AGREEMENTS SECTION */
.agreements {
  margin: auto;
  padding: 10px 40px;
}
p {
  font-size: 0.7rem;
}
/* PAYPAL IMG */
img {
  width: 17%;
  margin: 0 5px;
  vertical-align: -25%;
}

/* BOLDING SPAN */
.bold {
  text-transform: uppercase;
  font-weight: 900;
}
.submit-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.gus-actions {
  width: 100%;
}
/* Przycisk GUS - kolorystyka i hover jak .primary-button (np. "Wykorzystaj kod") */
.gus-btn.v-btn:not(.v-btn--disabled) {
  background-color: #c5c0b9 !important;
  color: #54514c !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  transition: all 0.3s;
}
.gus-btn.v-btn:not(.v-btn--disabled):hover {
  background-color: #e5e5e5 !important;
}
.gus-btn.v-btn::before {
  display: none;
}
/* Wyrównanie przycisku "Dokonaj płatności" do szerokości formularza (v-form ma padding 30px) */
#paymentForm {
  padding: 0 30px;
  width: 100%;
}

/* MEDIA QUERIES ----------------------------------- */
@media screen and (max-width: 1100px) {
  div /deep/ .v-text-field {
    width: 100%;
  }
}

@media screen and (max-width: 900px) {
  .container {
    padding: 20px 40px;
  }
  div /deep/ .v-text-field {
    width: 100%;
  }
  p {
    font-size: 0.6rem;
  }
}
@media screen and (max-width: 700px) {
  p {
    font-size: 0.6rem;
  }
}
@media screen and (max-width: 400px) {
  div /deep/ .v-text-field {
    width: 100%;
  }
}
</style>
